export default {
  ADD_ITEM (state, item) {
    state.items.unshift(item)
  },
  SET_META (state, meta) {
    state.meta = meta
  },
  SET_ITEMS (state, items) {
    console.log(items, 888888)
    state.items = items
  },
  UPDATE_ITEM (state, product) {
    const productIndex = state.items.findIndex((p) => p.id === product.id)
    Object.assign(state.items[productIndex], product)
  },
  REMOVE_ITEM (state, itemId) {
    const ItemIndex = state.items.findIndex((p) => p.id === itemId)
    state.items.splice(ItemIndex, 1)
  }
}
